import { oc } from "@orpc/contract";
import { z } from "zod";
import { McpLibraryEntrySchema, McpLibraryTestResultSchema } from "../wire.js";
// The Builder's "Add a tool server" catalog (V2's two REST routes, procedures since V6 plan
// row H.15): the curated MCP servers this deployment offers, and a live probe of one of them.
// Both need a caller: a session, or a key.
//
// A key may call both. The list holds no account data: its entries are the server-side catalog
// as published. A credential the deployment keeps for a server rides as a request header and
// never appears in an answer, but an entry's URL may carry the credential its server requires
// (a key in the URL the catalog publishes), and the list serves that URL as it is. A front-end
// or CLI that configures an agent's tool servers needs it, so it is a read. The probe changes
// nothing the caller owns but makes the server call a third party, so it is a write: a read key
// stays free of side effects. It takes a catalog id, never a URL, and the per-account window
// bounds it for every credential together. Neither names a project, so a key held to one
// project is refused both (api_key_project_scoped), as for any account-wide procedure.
/** Probes per account per minute: a person tries a few servers, a script does not get to scan. */
export const MCP_LIBRARY_TESTS_PER_MINUTE = 20;
export const mcpLibrary = {
    list: oc
        .route({
        summary: "The tool-server library",
        description: "The server-side catalog of curated MCP servers the Builder offers, in catalog order: inactive ones too (shown as coming soon). An entry's URL is served as the catalog publishes it, so it may carry the credential that server requires. A credential this deployment keeps for a server rides as a request header and never appears here; an entry whose server needs one this deployment lacks, and whose URL carries none of its own, is served inactive.",
    })
        .meta({ access: "read" })
        .output(z.object({ entries: z.array(McpLibraryEntrySchema) })),
    test: oc
        .route({
        summary: "Probe one tool server live",
        description: `Whether the library entry answers as an MCP server: initialize and tools/list through the server's guarded fetch, within 5 seconds. Answers ok with at most 12 tool names and the latency, or ok: false with error timeout, invalid_response or unreachable; never the server's own words. An unknown or inactive entry is 404 mcp_library_entry_not_found; more than ${MCP_LIBRARY_TESTS_PER_MINUTE} probes a minute per account is 429 rate_limited.`,
    })
        .meta({ access: "write" })
        .input(z.object({ entryId: z.string().min(1).max(100) }))
        .output(McpLibraryTestResultSchema),
};
//# sourceMappingURL=mcp-library.js.map